fragment ContentHero on contentHero_MatrixField {
    ... on contentHeroBlock_Entry {
        image {
            url
            width
            height
            title
            w249: url @transform(width: 249, format: "webp", mode: "crop")
            w340: url @transform(width: 340, format: "webp", mode: "crop")
            w364: url @transform(width: 364, format: "webp", mode: "crop")
            w418: url @transform(width: 418, format: "webp", mode: "crop")
            w605: url @transform(width: 605, format: "webp", mode: "crop")
            w768: url @transform(width: 768, format: "webp", mode: "crop")
            w1022: url @transform(width: 1022, format: "webp", mode: "crop")
            w2044: url @transform(width: 2044, format: "webp", mode: "crop")
            w249_avif: url @transform(width: 249, format: "avif", mode: "crop")
            w340_avif: url @transform(width: 340, format: "avif", mode: "crop")
            w364_avif: url @transform(width: 364, format: "avif", mode: "crop")
            w418_avif: url @transform(width: 418, format: "avif", mode: "crop")
            w605_avif: url @transform(width: 605, format: "avif", mode: "crop")
            w768_avif: url @transform(width: 768, format: "avif", mode: "crop")
            w1022_avif: url @transform(width: 1022, format: "avif", mode: "crop")
            w2044_avif: url @transform(width: 2044, format: "avif", mode: "crop")
        }
        videoMp4 {
            title
            url
        }
        videoWebM {
            title
            url
        }
        id
        title
        description
        caption
        backgroundColor
        imagePosition
    }
}
